var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22,13a2,2,0,0,0-2-2H19V8A5,5,0,0,0,9,8v3H8a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2ZM11,8a3,3,0,0,1,6,0v3H11Z","transform":"translate(-6 -3)","fill":"currentColor"}));
}

Lock.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20"};

module.exports = Lock;

Lock.default = Lock;
